import Alerts from '../pages/Alerts';

const routesConfig = [
  {
    path: '/alerts',
    title: 'Alerts',
    component: Alerts,
  },
];

export default routesConfig;
